export default __webpack_public_path__ + "static/media/kadhi.333e058e.jpg";